import { FC } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Button from "components/CustomButton";

import styles from "./styles";

type MintNFTStepProps = {
  isLoading: boolean;
  onPay: () => Promise<void>;
  onCancel?: () => void;
  children: JSX.Element | null;
};

const MintNFTStep: FC<MintNFTStepProps> = ({
  isLoading,
  onPay,
  onCancel,
  children,
}) => {
  return (
    <>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="flex-center"
        width="100%"
        style={{ marginTop: 5 }}
      >
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
        >
          <Typography component="h4" variant="h4" gutterBottom mb={3}>
            Are you sure you want to mint your NFT?
          </Typography>
          <Typography paragraph>
            It is an irreversible action and after minting, it will not be
            possible to return the item.
          </Typography>
        </Box>
      </Box>

      <Box>{children}</Box>
      <Box
        display="flex"
        width="100%"
        alignItems="end"
        mb={1}
        mt={2}
        justifyContent="center"
      >
        <Box mx={1}>
          <Button
            disabled={isLoading}
            minWidth
            sx={styles.button}
            onClick={onCancel}
            color="secondary"
          >
            Cancel
          </Button>
        </Box>
        <Box mx={1}>
          <Button
            disabled={isLoading}
            minWidth
            sx={styles.button}
            onClick={onPay}
            isLoading={isLoading}
          >
            Mint NFT
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default MintNFTStep;
